import { createFileRoute } from '@tanstack/react-router'

import { EventsDetailsPanel } from '@/events/components/EventsDetailsPanel'

export const Route = createFileRoute(
  '/company/_management/events/overview/$mediaId/$tab',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <EventsDetailsPanel />
}
